export const accountEL = {
    myAccount : "Λογαριασμός",
    profile : "ΠΡΟΦΙΛ",
    addresses : "ΔΙΕΥΘΥΝΣΕΙΣ",
    history : "ΙΣΤΟΡΙΚΟ",
    comments : "ΣΧΟΛΙΑ",
    settings : "ΡΥΘΜΙΣΕΙΣ",
    psw : "Αλλαγή Password",
    updateAlert : "Επιτυχής Αλλαγή Στοιχείων",
    updateError : "Αποτυχία Ενημέρωσης",
    registerToEdit : "Συνδεθείτε ή εγγραφείτε για να αποθηκεύσετε τα στοιχεία σας.",
    addAddress : "Προσθέστε μία διεύθυνση",
    addNewAddress : "Προσθέστε νέα διεύθυνση",
    myLocation : "Η Τοποθεσία μου",  
    modalHeaderUpdate : "Αλλαγή Διεύθυνσης",
    otherLocation : "Άλλη Τοποθεσία",
    home : "Οικία",
    work : "Εργασία",
    helperText : "Εισάγετε τα στοιχεία της διεύθυνσής σας",
    addressComments : "Σημειώσεις για τη διεύθυνση",
    historyPlaceholder : "Δεν έχετε κάνει ακόμα καμία αγορα",
    commentPlaceholder : "Δεν έχετε κάνει ακόμα κάποιο σχόλιο",
    emptyHistory: "Δεν έχετε κάνει ακόμη κάποια παραγγελία",
    uploadAvatar: "Κάνετε κλικ στην εικόνα για να επιλέξετε διαφορετική εικόνα.",
    submit: "ΥΠΟΒΟΛΗ",
    uploadSuccess: "Ανέβασμα εικόνας επιτυχές",    
    uploadError: "Ανέβασμα εικόνας λανθασμένο",
    bigFile: "Η εικόνα είναι πολύ μεγάλη. Θα πρέπει να είναι έως 1MB. Παρακαλώ επιλέξτε μία διαφορετική εικόνα",
    favorites: "Αγαπημένα",
    hello: "Γειά σου",
    profileHeader: "Προφίλ",
    settingsSmall: "Ρυθμίσεις",
    newPassword: "Νέο Password",
    repeatNewPassword: "Επανάληψη Νέου Password",
    passwordChangeSuccess: "Επιτυχής αλλαγή password",
    passwordChangeError: "Ανεπιτυχής αλλαγή password, ",
    passwordMismatch: "Το επαναληπτικό password δεν ταιριάζει"
}
